<template>
  <div class="babybooksetting">
    <div>
      <editCube6 title="付款資訊" keyname="BabyPayInfo"/>
      <editCube7 title="訂金設定"/>
      <editCube title="預約活動-時段說明" keyname="visitTimeDescBaby"/>
      <editCubeMsg :style="{marginTop:'60px'}" :isSwitch="'babySendSuccessMessage'" :switchValue="babySendSuccessMessage"
      :value="babySuccessMessage||''" :title="'預約成功訊息(手機簡訊)'" :edit="editMsg" @edit="editMsg=true" @cancel="editMsg=false"
      @update="update('babySuccessMessage', 'value', $event.successMessage, 'editMsg')" @updateSwitch="update('babySendSuccessMessage', 'bool', $event)"
        :template="`【成美文化園】
您好，感謝您預約成美周晬禮讚 {預約日期}，{預約時間}，{大人小孩}。

兆豐017南京東路分行，
帳號 :07009002016，
本次預購訂金為$3880。

第5位成人(13歲以上)起加收$200元/人，現場結帳計費。
請於預約後72小時內匯款預購完成，並請拍照留存與來電通知已付款，始為報名成功。
若有疑問可來電/FB粉絲專頁洽詢小編，04-8221166#100，請勿回覆此簡訊。`"/>

      <editCubeMsg :style="{marginTop:'60px'}" :isSwitch="null" :switchValue="babySendConfirmMessage"
      :value="babyConfirmMessage||''" :title="'匯款成功訊息(手機簡訊)'" :edit="editMsg2" @edit="editMsg2=true" @cancel="editMsg2=false"
      @update="update('babyConfirmMessage', 'value', $event.successMessage, 'editMsg2')" @updateSwitch="update('babySendConfirmMessage', 'bool', $event)"
        :template="`【成美文化園】
您好， 成美周晬禮讚 {預約日期}，{預約時間}，{大人小孩}。{匯款金額}
繳款已確認，當日報到地點於「東園區售票處」(停車場內售票亭)，請提早15分鐘到達報到，以利加速報到程序。當日加購結帳接受現金、信用卡，臨時增加家屬以當場實際出席人數收費。期待您的蒞臨，謝謝。請勿回覆此簡訊。`"/>
    </div>
    <div>
      <div class="resttitle">
        <div>預約須知 <button v-if="!edit" class="editBtn" @click="edit=true"></button></div>
        <template v-if="!edit">
          <div>
            <img v-if="image&&image.filename" :src="`.${image.filename}`" class="imagebox2">
            <div v-else class="imagebox"></div>
          </div>
          <div class="ql-editor-box"><p v-html="babyBookDescription?babyBookDescription.replaceAll('\n', '<br>'):''"></p></div>
        </template>
        <template v-else>
          <label for="img" id="uploadimage" v-if="!image || !image.filename">
            <div class="uploadimage">
            <input type="file" id="img" accept="image/png, image/jpeg" @change="uploadFile($event, 'events')" hidden>
            </div>
          </label>
          <div v-else @click="deleteImage('babyBookImage', image.filename)"><img class="imagebox2" :src="`.${image.filename}`"></div>
          <div :style="{width: '100%'}"><QuillEditor v-model="babyBookDescription"/></div>
          <div class="btns">
            <button class="cancel" @click="edit=false">取消</button>
            <button class="confirm" @click="save('babyBookDescription', 'edit')">儲存</button>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor as QuillEditor } from 'vue-quill-editor'
import editCubeMsg from '../../components/editCubeMsgRestSet.vue'
import editCube from '../../components/editCube.vue'
import editCube6 from '../../components/editCube6.vue'
import editCube7 from '../../components/editCube7.vue'
import { deleteapi, uploadimage, postapi, getapi } from '../../store/fetch'
export default {
  components: {
    editCube,
    editCube6,
    editCube7,
    editCubeMsg,
    QuillEditor
  },
  data () {
    return {
      editMsg: false,
      editMsg2: false,
      edit: false,
      image: {
        filename: null
      },
      babyBookDescription: null,
      event: null,
      reserveNumDesc: null,
      visitTimeDesc: null,
      visitFooterDesc: null,
      successFooterDesc: null,
      babySendSuccessMessage: false,
      babySuccessMessage: null,
      babyConfirmMessage: null,
      babySendConfirmMessage: false
    }
  },
  name: '',
  mounted () {
    this.getdata()
  },
  methods: {
    async getdata () {
      this.babyBookDescription = await getapi('selections/babyBookDescription')
      this.babySendSuccessMessage = await getapi('selections/babySendSuccessMessage')
      this.babySuccessMessage = await getapi('selections/babySuccessMessage')
      this.babySendConfirmMessage = await getapi('selections/babySendConfirmMessage')
      this.babyConfirmMessage = await getapi('selections/babyConfirmMessage')
      this.babyBookImage = await getapi('selections/babyBookImage')
      this.image.filename = this.babyBookImage
    },
    async update (key, type, data, box) {
      const ret = await postapi(`selections/${key}`, { key: type, data })
      console.log('key', key, ret)
      this[key] = ret
      if (box) { this[box] = false }
    },
    async save (key, box) {
      const ret = await postapi(`selections/${key}`, { key: 'value', data: this[key] })
      if (ret) {
        this[key] = ret
        this[box] = false
      }
    },
    async deleteImage (key, filename) {
      const ret = await deleteapi(`images${filename}`)
      if (ret) {
        // console.log(ret, 'deleteImage')
        const ret2 = await postapi(`selections/${key}`, { image: null })
        this.image = { filename: ret2.image }
      }
    },
    async uploadFile (event, folder) {
      const ret = await uploadimage(event, folder)
      const image = ret
      image.filename = `/${folder}/${image.filename}`
      // console.log(image.filename)
      await postapi('selections/babyBookImage', { key: 'value', data: image.filename })
      // console.log(ret2)
      this.image = {
        filename: image.filename
      }
      this.edit = false
    }
  }

}
</script>
<style lang="scss">
.babybooksetting {
  .ql-container {
      height: fit-content;
  }
  .ql-editor {
    height: fit-content;
    font-family: 'Noto Sans TC';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 140%;
    letter-spacing: 0.1em;
    color: #848484;
    * {
      font-family: inherit;
    }
    strong {
      font-weight: 700;
    }
    em {
      font-style: italic;
    }
    .ql-font-serif {
      font-family: serif;
    }
    .ql-font-monospace {
      font-family: 'Space Mono';
    }

  p {
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 140%;
    letter-spacing: 0.1em;
    color: #848484;
  }
  h1 {
    font-style: normal;
    font-weight: 500;
    font-size: 32px;
    line-height: 162%;
    color: var(--color-checked);
    text-align: start;
  }
  h2 {
    font-style: normal;
    font-weight: 500;
    font-size: 28px;
    line-height: 162%;
    color: var(--color-checked);
  }
  .ql-size-small {
    font-size: small;
  }
  .ql-size-large {
    font-size: larger;
  }
  .ql-size-huge {
    font-size: xx-large;
  }
  }
  .ql-size-large { font-size: large; }
  .ql-align-center {
    text-align: center;
  }
  img {
    width: 100%;
  }
  .ql-indent-2 {
    text-indent: 2em;
  }
  .ql-indent-1 {
    text-indent: 1em;
  }

}
.ql-editor-box {
height: fit-content;
font-family: 'Noto Sans TC';
font-style: normal;
font-weight: 400;
font-size: 20px;
line-height: 140%;
letter-spacing: 0.1em;
color: #848484;
* {
  font-family: inherit;
}
strong {
  font-weight: 700;
}
em {
  font-style: italic;
}
.ql-font-serif {
  font-family: serif;
}
.ql-font-monospace {
  font-family: 'Space Mono';
}

p {
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 140%;
  letter-spacing: 0.1em;
  color: #848484;
}
h1 {
  font-style: normal;
  font-weight: 500;
  font-size: 32px;
  line-height: 162%;
  color: var(--color-checked);
  text-align: start;
}
h2 {
  font-style: normal;
  font-weight: 500;
  font-size: 28px;
  line-height: 162%;
  color: var(--color-checked);
}
.ql-size-small {
  font-size: small;
}
.ql-size-large {
  font-size: larger;
}
.ql-size-huge {
  font-size: xx-large;
}
}
</style>
<style lang="scss" scoped>

.editCube {
  &>div:nth-child(1) {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    &>button {
      margin-left: auto;
      width: 35px;
      height: 35px;
      background-color: var(--color-checked);
      background-image: url(/pen.svg);
      background-position: center;
      background-repeat: no-repeat;
      border: none;
      border-radius: 50%;
      background-size: 19px;
    }
  }
}
.imagebox2 {
  max-width: 461px;
  max-height: 346px;
  resize: both;
}
.resttitle {
  text-align: start;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 25px;
  line-height: 29px;
  letter-spacing: 0.1em;
  color: var(--color-checked);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 9px;
  textarea, p {
    padding: 16px 20px;
    border: 1px solid var(--color-border);
    height: 469px;
    text-align: start;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 150%;
    letter-spacing: 0.1em;
    color: var(--color-letter);
    width: -webkit-fill-available;
    min-width: 1000px;
    overflow: auto;
  }
  &>div:nth-child(1) {
    width: 461px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    &>button {
      margin-left: auto;
      width: 35px;
      height: 35px;
      background-color: var(--color-checked);
      background-image: url(/pen.svg);
      background-position: center;
      background-repeat: no-repeat;
      border: none;
      border-radius: 50%;
      background-size: 19px;
    }
  }
}
.btns{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 28px;
  width: 100%;
  button {
    &:disabled {
      filter: contrast(.5);
    }
    border: none;
    width: 100px;
    height: 35px;
    border-radius: 20px;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    &.confirm {
      background: #E37878;
    }
    &.cancel {
      background: #B8B8B8;
    }
  }
}
.editBtn {
  margin-left: auto;
}
label#uploadimage {
  width: 461px;
  height: 346px;
}
.imagebox {
  width: 461px;
  height: 346px;
  background-color: #DADADA;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  // &::before {
  //   content: '';
  //   width: 576px;
  //   height: 1px;
  //   position: absolute;
  //   background-color: #999;
  //   transform: rotate(37deg);
  // }
  // &::after {
  //   content: '';
  //   width: 576px;
  //   height: 1px;
  //   position: absolute;
  //   background-color: #999;
  //   transform: rotate(-37deg);
  // }
}
.uploadimage {
  margin-right: auto;
  width: 461px;
  height: 346px;
  background-image: url(/upload.svg);
  background-size: contain;
  display: inline-flex;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-position: left;
  position: relative;
  &::before {
    position: absolute;
    content: '匯入圖片';
    display: inline-flex;
    width: 100px;
    height: 35px;
    background-color: var(--color-checked);
    align-items: center;
    justify-content: center;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    border-radius: 20px;
    left: 230px;
    top: 204px;
    transform: translateX(-50%);
  }
}
.babybooksetting {
  width: 100%;
  height: calc(100vh - 90px);
  display: grid;
  grid-template-columns: 636px 1fr;
  &>div:nth-child(1) {
    padding: 28px 43px;
    overflow-y: auto;
    height: calc(100vh - 90px);
    box-sizing: border-box;
  }
  &>div:nth-child(2) {
    padding: 28px 43px;
    box-sizing: border-box;
    height: calc(100vh - 90px);
    border-left: 1px solid var(--color-border);
    overflow-y: auto;
  }
}

</style>
